import { BigNumber } from 'ethers'
import { useSingleCallResult } from 'lib/hooks/multicall'
import { useMemo } from 'react'
import useActiveWeb3React from './useActiveWeb3React';

import { useRewardStorageContract } from './useContract'

/**
 * Does a lookup for an ENS name to find its address.
 */
export default function useRewardStorage(): { loading: boolean; threshold: BigNumber; reward: BigNumber } {
  const { account } = useActiveWeb3React()
  const inputs = useMemo(() => [account ?? undefined], [account])
  const rewardStorageContract = useRewardStorageContract(false)
  const threshold = useSingleCallResult(rewardStorageContract, 'rewardWithdrawThreshold')
  const reward = useSingleCallResult(rewardStorageContract, 'rewards', inputs)

  return useMemo(
    () => ({
      threshold: threshold.result?.[0] ?? BigNumber.from('0'),
      reward: reward.result?.[0] ?? BigNumber.from('0'),
      loading: false,
    }),
    [reward.result, threshold.result]
  )
}
